<template>
  <div>
    <a-card>
      <a-descriptions>
        <a-descriptions-item label="安华客户编号">
          {{ anlDetailDate.anlCode }}
        </a-descriptions-item>
        <a-descriptions-item label="订单号">
          {{ anlDetailDate.orderNo }}
        </a-descriptions-item>
        <a-descriptions-item label="信息">
          {{ bureauReportBasicInfo.message }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button type="primary" style="margin-right:10px" @click="download">
          下载财报
        </a-button>
        <a-button type="primary" @click="_archived">转存财报</a-button>
      </div>
      <h4>Company Financials</h4>
      <div class="annualTitle">
        <span style="font-weight: bold">资产负债表(Balance Sheet)</span>
      </div>
      <p style="font-weight:600;">
        <span>Currency：{{ detail.detailList[0].currency }}</span>
        &emsp;
        <span>Unit： 10,000</span>
      </p>
      <!--      资产(Assets)-->
      <table-view
        style="margin-top:20px;"
        :showPage="false"
        tableCardTitle="资产(Assets)"
        :columns="_colModel"
        rowKey="id"
        :pagination="false"
        :data="_currentAssetData"
      ></table-view>
      <!--     负债及所有者权益(Liabilities and Owners' Equity)-->
      <table-view
        :showPage="false"
        rowKey="id"
        :pagination="false"
        tableCardTitle="负债及所有者权益(Liabilities and Owners' Equity)"
        :columns="_colModel"
        :data="_EquityCurrentAsset"
      ></table-view>
      <div class="annualTitle">
        <span style="font-weight: bold">损益表(Income Statement)</span>
      </div>
      <p style="font-weight:600;">
        <span>Currency：{{ detail.detailList[0].currency }}</span>
        &emsp;
        <span>Unit： 10,000</span>
      </p>
      <!-- 项目(Items) -->
      <table-view
        style="margin-top:20px;"
        rowKey="id"
        :pagination="false"
        :showPage="false"
        tableCardTitle="项目(Items)"
        :columns="_colModel"
        :data="_ItemsData"
      ></table-view>
    </a-card>
  </div>
</template>

<script>
import { geReportDeatail, detailDownload, detailArchived } from '../../api'
import mixins from './mixins'
import { mapGetters } from 'vuex'
import numeral from 'numeral'
import { TableView } from 'lxfintech-fe'
export default {
  mixins: [mixins],
  data() {
    const formatAmount = num => {
      return numeral(num).format('0,0.00')
    }
    //这里存放数据
    return {
      currentAssetKeys: [
        'currentAssets',
        'monetaryFund',
        'transactionalFinancialAssets',
        'notesReceivable',
        'accountsReceivable',
        'otherReceivables',
        'advancePayment',
        'inventory',
        'nonCurrentAssetsDueWithinOneYear',
        'otherCurrentAssets',
        'totalNonCurrentAssets',
        'totalFixedAssets',
        'originalValueOfFixedAssets',
        'accumulatedDepreciation',
        'netFixedAssets',
        'projectsUnderConstruction',
        'longTermInvestment',
        'intangibleAssets',
        'deferredAssets',
        'longTermDeferredExpenses',
        'otherNonCurrentAssets',
        'totalAssets',
      ],
      nonCurrentAssetKeys: [
        'totalCurrentLiabilities',
        'shortTermBorrowing',
        'notesPayable',
        'accountsPayable',
        'otherPayables',
        'advancesFromCustomers',
        'payPayable',
        'taxesPayable',
        'nonCurrentLiabilitiesDueWithinOneYear',
        'otherCurrentLiabilities',
        'totalNonCurrentLiabilities',
        'longTermBorrowing',
        'longTermPayables',
        'bondsPayable',
        'otherNonCurrentLiabilities',
        'totalLiabilities',
        'paidInCapital',
        'capitalReserves',
        'surplusReserves',
        'undistributedProfit',
        'totalShareholderEquity',
        'totalLiabilitiesAndShareholdersEquity',
      ],
      currentLiabilityKeys: [
        'revenueFromMainOperations',
        'minusMainBusinessCost',
        'mainBusinessTaxesAndAdditionalTaxes',
        'mainBusinessProfit',
        'costOfSales',
        'managementFees',
        'financeCharges',
        'otherFees',
        'plusReturnOnInvestment',
        'otherBusinessProfits',
        'operatingProfit',
        'nonOperatingIncome',
        'nonOperatingExpenses',
        'plusPriorYearProfitAndLossAdjustment',
        'profitTotal',
        'lessIncomeTax',
        'netProfit',
      ],
      formatAmount,
      // table
      // current assets
      colYears: [], // column 纵向
      anlDetailDate: {},
    }
  },
  components: { TableView },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
    // table
    // current assets
    _colModel() {
      const _res = [{ title: '', dataIndex: '__name' }]
      this.colYears.forEach(item => {
        _res.push({
          title: `${item}`,
          dataIndex: `annual${item}`,
        })
      })
      return _res
    },
    _currentAssetData() {
      // 根据需要的key摘取数据
      return this.handleCommonTable(this.currentAssetKeys)
    },
    _EquityCurrentAsset() {
      return this.handleCommonTable(this.nonCurrentAssetKeys)
    },
    _ItemsData() {
      return this.handleCommonTable(this.currentLiabilityKeys)
    },
  },
  //方法集合
  methods: {
    async _archived() {
      const { id } = this.bureauReportBasicInfo
      await detailArchived(id)
      this.$message.success('转存财报成功')
    },
    async download() {
      const { id } = this.bureauReportBasicInfo
      await detailDownload(id)
    },
    // 接口数据
    async _getDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await geReportDeatail(id)
        this.anlDetailDate = data.anLDetailReport
        this.detail = data
        this.colYears = this.detail.detailList.map(item => item.year)
      } catch (err) {
        console.error(err)
      }
    },
    transTbData(sourceData) {
      const _arr = []
      if (!sourceData.length) {
        return []
      } else {
        const len = Object.keys(sourceData[0].data)?.length
        for (let i = 0; i < len; i++) {
          const _obj = {}
          for (let j = 0; j < sourceData.length; j++) {
            const key = Object.keys(sourceData[j].data)[i]
            ;(_obj['__name'] = mixins.methods.transKeyToLabel(key)),
              (_obj[`annual${sourceData[j].year}`] =
                typeof Number(sourceData[j].data[key]) === 'number'
                  ? this.formatAmount(sourceData[j].data[key])
                  : sourceData[j].data[key])
          }
          _arr.push(_obj)
        }
      }
      return _arr
    },
    handleCommonTable(showKeys) {
      const _res = []
      if (
        this.detail &&
        this.detail.detailList &&
        this.detail.detailList.length
      ) {
        this.detail.detailList.forEach(item => {
          const _obj = {}
          Object.keys(item).forEach(key => {
            if (showKeys.indexOf(key) !== -1) {
              _obj[key] = item[key]
            }
          })
          _res.push(_obj)
        })
      }
      console.log(_res)
      for (let i = this.colYears.length - 1; i >= 0; i--) {
        if (_res.length) {
          _res[i]['year'] = this.colYears[i]
        }
      }
      // 处理成需要的数据结构
      for (let i = 0; i < _res.length; i++) {
        _res[i]['data'] = {}
        for (const _key of showKeys) {
          _res[i]['data'][_key] = _res[i][_key]
          delete _res[i][_key]
        }
      }
      return this.transTbData(_res)
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getDetail()
  },
}
</script>
<style scoped>
.text-right {
  text-align: right;
  margin-bottom: 20px;
}
.annualTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* @import url(); 引入css类 */
</style>
